module.exports = __webpack_public_path__ + "static/media/book.7b8e0080.svg";